import { getToDay } from '@/utils/date';
import { message } from 'antd';
import {
  search_dayv2 as search_day,
  aggregatev2 as aggregate,
  search_day_exportv2 as search_day_export,
} from '../services';
import { isArea } from '@/services/area';
import moment from 'moment';
import { mapColumn } from '@/utils/column';
import { isAreaData } from '@/services/area';
let [startDate] = getToDay();

export default {
  namespace: 'LineLoadingRateSr',
  state: {
    searchParams: {
      startDate: moment(startDate).subtract(6, 'days').format('YYYY-MM-DD'),
      endDate: moment(startDate).format('YYYY-MM-DD'),
      lineType: '3',
      transportLineType: ['区内', '区域', '长途', '短途'],
      businessType: ['干线'],
      taskAttribute: '',
      transportStatus: '',
      dimension: 2,
      operationType: 1,
    },

    page: 1,
    pageSize: 50,
    total: 0,

    onSearch: false,
    tableDatas: [],
    // calcWeightCount: 0, // 结算重量之和
    // volumeCount: 0, // 体积之和
    // actualCapacityCount: 0, // 实际运力之和
    // actualPositionCount: 0, // 实际仓位之和

    actualCapacity: 0, // 实际运力之和
    totalCalcWeightRate: 0, // 结算装载率
    totalCalcWeight: 0, // 结算重量之和
    totalVolume: 0, // 体积之和
    totalVolumeRate: 0, // 体积装载率
    avgTicketOfVotes: 0, // 票均重之和
    exportVisible: false,
    settlementProportion: 0, // 结算满载比
    avgFullRateStandard: 0, // 满载率标准

    access: {
      isHead: false,
      isArea: false,
      isCenter: true,
      code: '',
    },
  },

  effects: {
    // 分页查询
    *getDatas(_, { call, put, select }) {
      const LineLoadingRateSr = yield select(({ LineLoadingRateSr }) => LineLoadingRateSr);
      try {
        const isDepartureArea = yield Promise.resolve(
          isAreaData(LineLoadingRateSr?.searchParams?.departureCenter?.code),
        );
        const isArrivalArea = yield Promise.resolve(
          isAreaData(LineLoadingRateSr?.searchParams?.arrivalCenter?.code),
        );
        const obj = handler(LineLoadingRateSr, isDepartureArea, isArrivalArea);
        const result = yield call(search_day, obj);

        if (result?.code === 1 && result?.data) {
          yield put({
            type: 'updateState',
            payload: {
              tableDatas: result?.data?.rows || [],
              total: result.data?.total || 0,
            },
          });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },
    // 按钮查询
    *search_day(_, { put, select }) {
      const LineLoadingRateSr = yield select(({ LineLoadingRateSr }) => LineLoadingRateSr);
      try {
        const isDepartureArea = yield Promise.resolve(
          isAreaData(LineLoadingRateSr?.searchParams?.departureCenter?.code),
        );
        const isArrivalArea = yield Promise.resolve(
          isAreaData(LineLoadingRateSr?.searchParams?.arrivalCenter?.code),
        );
        const obj = handler(LineLoadingRateSr, isDepartureArea, isArrivalArea);
        const [result, data] = yield Promise.all([search_day(obj), aggregate(obj)]);
        if (result?.code === 1 && result?.data) {
          yield put({
            type: 'updateState',
            payload: {
              tableDatas: result?.data?.rows || [],
              total: result.data?.total || 0,
            },
          });
        } else {
          yield put({
            type: 'updateState',
            payload: {
              tableDatas: [],
              total: 0,
            },
          });
        }
        // 解决data.data是个空数组的情况无法重置
        if (data?.code === 1 && data?.data && !Array.isArray(data?.data)) {
          yield put({
            type: 'updateState',
            payload: {
              ...data?.data,
            },
          });
        } else {
          yield put({
            type: 'updateState',
            payload: {
              totalCalcWeight: 0,
              actualCapacity: 0,
              totalCalcWeightRate: 0,
              totalVolume: 0,
              totalVolumeRate: 0,
              avgTicketOfVotes: 0,
              settlementProportion: 0,
              avgFullRateStandard: 0,
            },
          });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },

    *exportDay({ payload }, { call, put, select }) {
      const LineLoadingRateSr = yield select(({ LineLoadingRateSr }) => LineLoadingRateSr);
      try {
        const isDepartureArea = yield Promise.resolve(
          isAreaData(LineLoadingRateSr?.searchParams?.departureCenter?.code),
        );
        const isArrivalArea = yield Promise.resolve(
          isAreaData(LineLoadingRateSr?.searchParams?.arrivalCenter?.code),
        );
        const obj = handler(LineLoadingRateSr, isDepartureArea, isArrivalArea);
        obj.columns = payload.choiceColumns;
        // obj.exportFlag = 1;

        const result = yield call(search_day_export, obj);

        if (result?.code === 1) {
          message.success('导出成功');
          yield put({
            type: 'updateState',
            payload: {
              exportVisible: false,
            },
          });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },

    resetState(state) {
      return { state, tableDatas: [], offset: undefined };
    },
  },
};

const handler = (LineLoadingRateSr, isDepartureArea, isArrivalArea) => {
  const { page, pageSize, searchParams, access } = LineLoadingRateSr;

  const {
    departureCenter,
    arrivalCenter,
    transportLineType,
    businessType,
    startDate,
    endDate,
    lineType,
    dataStrList,
    // eslint-disable-next-line no-unused-vars
    orderNos,
    // eslint-disable-next-line no-unused-vars
    ischecked,
    ...others
  } = searchParams;
  if (!access.isHead) {
    if (departureCenter) {
      if (departureCenter.length === 0) {
        throw new Error('请选择出发站点/营运区/区域');
      }
    } else {
      throw new Error('请选择出发站点/营运区/区域');
    }
  }

  let obj = {
    page,
    pageSize,
    startDate: moment(startDate).format('YYYY-MM-DD'),
    endDate: moment(endDate).format('YYYY-MM-DD'),
    ...others,
  };
  // 需要注意的地方
  if (departureCenter) {
    obj.departureLevel = departureCenter?.siteTypeCode === '区域' ? 3 : isDepartureArea ? 1 : 2;
    obj.departureCode = departureCenter.code;
  }
  if (arrivalCenter) {
    obj.arrivalLevel = arrivalCenter?.siteTypeCode === '区域' ? 3 : isArrivalArea ? 1 : 2;
    obj.arrivalCode = arrivalCenter.code;
  }
  if (transportLineType && transportLineType.length > 0) {
    obj.transportLineType = transportLineType.join(',');
  }
  if (businessType && businessType.length > 0) {
    obj.businessType = businessType.join(',');
  }
  if (!obj.planCarCabinetTypeList?.length) {
    obj.planCarCabinetTypeList = null;
  }
  if (!obj.carCabinetTypeList?.length) {
    obj.carCabinetTypeList = null;
  }
  // if (lineType === '3') {
  //   obj.lineName = undefined;
  //   obj.taskNo = dataStrList && dataStrList.length > 0 ? dataStrList.join(',') : undefined;
  //   obj.direction = undefined;
  // }
  // if (lineType === '1' || lineType === '2') {
  //   obj.taskNo = undefined;
  //   obj.lineName = dataStrList && dataStrList.length > 0 ? dataStrList.join(',') : undefined;
  //   obj.direction = undefined;
  // }
  // if (lineType === '4') {
  //   obj.taskNo = undefined;
  //   obj.lineName = undefined;
  //   obj.direction = dataStrList && dataStrList.length > 0 ? dataStrList.join(',') : undefined;
  // }

  if (lineType === '3') {
    obj.lineName = undefined;
    obj.taskNo =
      (dataStrList &&
        dataStrList
          .split('\n')
          .map((item) => item.trim())
          .filter((item) => item)
          .join(',')) ||
      undefined;
    obj.direction = undefined;
  }
  if (lineType === '1' || lineType === '2') {
    obj.taskNo = undefined;
    obj.lineName =
      (dataStrList &&
        dataStrList
          .split('\n')
          .map((item) => item.trim())
          .filter((item) => item)
          .join(',')) ||
      undefined;
    obj.direction = undefined;
  }
  if (lineType === '4') {
    obj.taskNo = undefined;
    obj.lineName = undefined;
    obj.direction =
      (dataStrList &&
        dataStrList
          .split('\n')
          .map((item) => item.trim())
          .filter((item) => item)
          .join(',')) ||
      undefined;
  }
  obj.lineType = Number(lineType);
  return obj;
};
